/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useCallback } from 'react';
import { AjaxContext } from 'commons-ui';
import { ISegmentConfigData } from './type';
import { UPDATE_CONFIG_URI } from '../../tdsHelper';

const useService = () => {
	const [isActive, setIsActive] = React.useState<{ id: boolean; label: string }>({ id: true, label: 'TEST' });
	const { postData } = useContext(AjaxContext);

	const requestUpdateConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		return postData({
			endpoint: UPDATE_CONFIG_URI,
			body: { tdsAbsorptionConfigs: data },
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		requestUpdateConfig,
		isActive,
		setIsActive
	};
};

export default useService;
